import React, { useContext, useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserInfo } from "../Context/UserInfoContext";
import { MedicalContext } from '../Context/MedicalContext';
import CryptoJS from "crypto-js";
import { jwtDecode } from 'jwt-decode';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Modal } from 'flowbite-react';
import medhistory from "../../../JSONS/medhistory.json";
import medhisCodes from "../../../JSONS/medhis_codes.json"

const UserProfileMedicalData = () => {

    const Navigate = useNavigate();
    const MySwal = withReactContent(Swal)

    const {
        LoggedOut
    } = useContext(UserInfo);

    const {
        PerRecordsCodes, FamRecordsCodes
    } = useContext(MedicalContext);

    const [OneTime,setOneTime] = useState(true)
    const [Reload,setReload] = useState(false)
    const [IMC,setIMC] = useState(false)
    const [PMH,setPMH] = useState([])
    const [FMH,setFMH] = useState([])
    const [TmpPMH,setTmpPMH] = useState([])
    const [TmpFMH,setTmpFMH] = useState([])
    const [Cardios,setCardios] = useState([])
    const [CardioUp,setCardioUp] = useState([])
    const [ShowCardios,setShowCardios] = useState(false)
    const [FamCardio,setFamCardio] = useState(false)
    const [FamCardioMissing,setFamCardioMissing] = useState(false)
    const [Parameters,setParameters] = useState(false)
    const [NewPhone,setNewPhone] = useState("")
    const [EditPhone,setEditPhone] = useState(false)
    const [TaskDone,setTaskDone] = useState(false)
    const [EnoughInfo,setEnoughInfo] = useState(window.localStorage.getItem("OpenAccess"))

    const [OpenModal1,setOpenModal1] = useState(false)
    const [OpenModal2,setOpenModal2] = useState(false)
    const [OpenModal3,setOpenModal3] = useState(false)

    const [Height,setHeight] = useState("")
    const [Weight,setWeight] = useState("")
    const [Abs,setAbs] = useState("")
    const [Neck,setNeck] = useState("")
    //const [Systolic,setSystolic] = useState("")
    //const [Diastolic,setDiastolic] = useState("")
    const [validation,setvalidation] = useState({
        "Height": "empty",
        "Weight": "empty",
        "Abs": "empty",
        "Neck": "empty",
        //"Systolic": "empty",
        //"Diastolic": "empty",
    })

    const [validation2,setvalidation2] = useState({
        "Phone": "valid",
    })

    const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
    const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;
    const Name = decodedToken ? decodedToken.name : null
    const Rut = decodedToken ? decodedToken.rut : null
    const Email = decodedToken ? decodedToken.email : null
    const Phone = sessionStorage.getItem('Phone') ? sessionStorage.getItem('Phone') : decodedToken ? decodedToken.phone : null
    const Gender = decodedToken ? parseInt(decodedToken.gender) : null;
    const GenderCat = Gender === 1 ? "M" : "F"
    const DoB = decodedToken ? new Date(decodedToken.born) : null;
    const DoBMonth = DoB ? DoB.getMonth() + 1 : 0
    const DoBDay = DoB ? DoB.getDate() : 0
    const Region = decodedToken ? decodedToken.region : null
    const Commune = decodedToken ? decodedToken.commune : null
    const cancers = ["AF029","AF030","AF031","AF032","AF033","AF034"]
    const cardios = ['AP036','AP037','AP038','AP039','AP040','AP041','AP042','AP043','AP044','AP045']

    const allowed = decodedToken && decodedToken.first_survey === false && window.localStorage.getItem("OpenAccess") ? JSON.parse(window.localStorage.getItem("OpenAccess")) : decodedToken ? decodedToken.first_survey : null

    function AgeCalc() {
        const currentDate = new Date();
        let dob = new Date(DoB)
    
        const age = currentDate.getFullYear() - dob.getFullYear();
        const currentMonth = currentDate.getMonth();
        const currentDay = currentDate.getDate();
    
        if (age > 15) {
          if (currentMonth > DoBMonth-1 || (currentMonth === DoBMonth-1 && currentDay >= DoBDay)) {
            return age;
          } else {
            return age-1;
          }
        } else if (age === 15) {
    
          if (currentMonth > DoBMonth-1 || (currentMonth === DoBMonth-1 && currentDay >= DoBDay)) {
            return age;
          }
        }
    
        return false;
    }
    const Age = AgeCalc()
    const ageCat = Age <= 40 ? "15-40" : Age <= 60 ? "41-60" : ">60"

    function getIMC(height, weight) {
        let imc = parseInt(weight)/(parseInt(height)/100)**2
        let cats = ["Bajo", "Saludable", "Sobrepeso", "Obesidad I", "Obesidad II", "Obesidad III"]
        let which = 0
        let ideal = [0,0]
        if(imc < 18.5) {
            which = 0
        } else if(imc < 25 & imc >= 18.5) {
            which = 1
        } else if(imc < 30 & imc >= 25) {
            which = 2
        } else if(imc < 35 & imc >= 30) {
            which = 3
        } else if(imc < 40 & imc >= 35) {
            which = 4
        } else {
            which = 5
        }
        ideal[0] = Math.round(((height/100)**2) * 18.5)
        ideal[1] = Math.round(((height/100)**2) * 25)
        return [imc, cats[which], which, ideal]
    }

    const handleChange = (value, setValue) => {
        const result = value.replace(/\D/g, '');
        setValue(result.slice(0, 3));
    };

    function verifyData() {
        let isWeightValid = Weight.trim() === "" ? "invalid" : "valid";
        let isHeightValid = Height.trim() === "" ? "invalid" : "valid";
        let isNeckValid = Neck.trim() === "" ? "valid" : "valid";
        let isAbsValid = Abs.trim() === "" ? "valid" : Abs < 30 ? "invalid" : Abs > 300 ? "invalid" : "valid";
        //let isSystolicValid = Systolic.trim() === "" ? "valid" : Systolic < 40 ? "invalid" : Systolic > 370 ? "invalid" : "valid";
        //let isDiastolicValid = Diastolic.trim() === "" ? "valid" : Diastolic < 20 ? "invalid" : Diastolic > 360 ? "invalid" : "valid";
    
        if(Weight < 2 || Weight > 650) {
            isWeightValid = "invalid"
        }
        if(Height < 54 || Height > 272) {
            isHeightValid = "invalid"
        }
        if(Neck.trim() !== "" && (Neck < 30 || Neck > 60)) {
            isNeckValid = "invalid"
        }

        setvalidation({
            "Weight": isWeightValid,
            "Height": isHeightValid,
            "Abs": isAbsValid,
            "Neck": isNeckValid,
            //"Systolic": isSystolicValid,
            //"Diastolic": isDiastolicValid,
        });
        let answers = [isWeightValid,isHeightValid,isAbsValid,isNeckValid]
    
        if(!answers.includes("invalid")) {
            uploadResults()
        }
    }

    const requestGetPatient = useCallback(async() => {

        MySwal.fire({
            position: "center",
            html: 
            <div className="FullAlertWidth1">
                <div className="FullAlertUpTitle">Cargando información de perfil...</div>
                <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
            </div>,
            color: "#340066",
            customClass: 'swal-wide',
            showConfirmButton: false,
            width: "100%",
        })

        let parameters = {
            rut: decodedToken.rut
        }
    
        let requestOptions = {
          method: 'POST',
          redirect: 'follow',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(parameters)
        };

        let parameters2 = {
            rut: decodedToken.rut,
            within: [51,52,56,57],
            //within: [51,52,53,54,56,57]
        }
    
        let requestOptions2 = {
            method: 'POST',
            redirect: 'follow',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(parameters2)
        };
    
        try{
            let resp = await fetch("https://ymc-doc-api.azurewebsites.net/getprofiledata", requestOptions)
            if (resp.status !== 200){
                MySwal.fire({
                    icon: "error",
                    title: "Ocurrió un error obteniendo los datos",
                    text: "Por favor inténtelo más tarde",
                    showConfirmButton: true
                });
                return false;
            }
            let data = await resp.json();

            let pmhs = false
            let fmhs = false
            
            if(data.pmh) { 
                pmhs = [...data.pmh]
                if(pmhs.includes("AP035")) {
                    setShowCardios(true)
                    if(data.enf_card) {
                        setCardios([...data.enf_card])
                        setCardioUp([...data.enf_card])
                    }
                }
            }
            if(data.fmh) {
                fmhs = [...data.fmh]
                if(fmhs.includes("AF025") && data.fam_card) {
                    setFamCardio(data.fam_card)
                }
            }

            let hasParams = true
            let resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/getuserparams", requestOptions2)
            if (resp2.status !== 200){
                if(resp2.status !== 500) {
                MySwal.fire({
                    icon: "error",
                    title: "Ocurrió un error al subir los datos",
                    text: "Por favor inténtelo más tarde",
                    showConfirmButton: true
                });
                return false;
                } else {
                hasParams = false
                }
            }
            let data2 = await resp2.json();
            
            if(hasParams) {
                if(data2.params["51"] && data2.params["52"]) {
                    let imc = getIMC(data2.params["52"][1],data2.params["51"][1])
                    setIMC(imc)
                }
                if(data2.params["51"]) setWeight(data2.params["51"][1])
                if(data2.params["52"]) setHeight(data2.params["52"][1])
                if(data2.params["56"]) setAbs(data2.params["56"][1])
                if(data2.params["57"]) setNeck(data2.params["57"][1])
                //if(data2.params["53"]) setSystolic(data2.params["53"][1])
                //if(data2.params["54"]) setDiastolic(data2.params["54"][1])
                setParameters(data2.params)
            }

            if(pmhs) { 
                setPMH([...pmhs])
                setTmpPMH([...pmhs])
            }
            if(fmhs) {
                setFMH([...fmhs])
                setTmpFMH([...fmhs])
            }
    
            MySwal.close();
            setTaskDone(true);
        }
        catch(error){
            MySwal.close();
            alert("Ocurrió un error procesando la búsqueda");
            return false;
        }
        MySwal.close();
        setTaskDone(true);
    },[MySwal,decodedToken]);

    const uploadResults = async() => {
        MySwal.fire({
            position: "center",
            html: 
            <div className="FullAlertWidth1">
                <div className="FullAlertUpTitle">Subiendo parámetro...</div>
                <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
            </div>,
            color: "#340066",
            customClass: 'swal-wide',
            showConfirmButton: false,
            width: "100%",
        })

        let saveWeight = Parameters && Parameters["51"] && parseInt(Parameters["51"]) !== parseInt(Weight) && Weight.length !== 0 ? true : (Parameters && Parameters["51"]) || Weight.length === 0 ? false : true
        let saveHeight = Parameters && Parameters["52"] && parseInt(Parameters["52"]) !== parseInt(Height) && Height.length !== 0 ? true : (Parameters && Parameters["52"]) || Height.length === 0 ? false : true
        let saveAbs = Parameters && Parameters["56"] && parseInt(Parameters["56"]) !== parseInt(Abs) && Abs.length !== 0 ? true : (Parameters && Parameters["56"]) || Abs.length === 0 ? false : true
        let saveNeck = Parameters && Parameters["57"] && parseInt(Parameters["57"]) !== parseInt(Neck) && Neck.length !== 0 ? true : (Parameters && Parameters["57"]) || Neck.length === 0 ? false : true
        //let saveSys = Parameters && Parameters["53"] && parseInt(Parameters["53"]) !== parseInt(Systolic) && Systolic.length !== 0 ? true : (Parameters && Parameters["53"]) || Systolic.length === 0 ? false : true
        //let saveDia = Parameters && Parameters["54"] && parseInt(Parameters["54"]) !== parseInt(Diastolic) && Diastolic.length !== 0 ? true : (Parameters && Parameters["54"]) || Diastolic.length === 0 ? false : true

        let finalParamids = [
            saveWeight ? 51 : false,
            saveHeight ? 52 : false,
            saveAbs ? 56 : false,
            saveNeck ? 57 : false,
            //saveSys ? 53 : false,
            //saveDia ? 54 : false
        ].filter(med => med !== false);
        let finalResults = [
            saveWeight ? Weight : false,
            saveHeight ? Height : false,
            saveAbs ? Abs : false,
            saveNeck ? Neck : false,
            //saveSys ? Systolic : false,
            //saveDia ? Diastolic : false
        ].filter(med => med !== false);

        let Dated = new Date()
    
        let parameters = {
          rut: decodedToken.rut,
          sex: GenderCat,
          ans: finalResults,
          ids: finalParamids,
          date: Dated
        }
    
        let requestOptions = {
            method: 'POST',
            redirect: 'follow',
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(parameters)
        };
      
        try{
            
            const resp = await fetch("https://ymc-graph-api.azurewebsites.net/addnewparamresults", requestOptions)
            if (resp.status !== 200){
              MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al subir los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
              });
              return false;
            }
      
            if(allowed) {
                MySwal.close()
                setOpenModal1(false)
                setReload(true)
            } else {
                grantAccess()
            }
            return true
        }
        catch(error){
            MySwal.fire({
              icon: "error",
              title: "Ocurrió un error al subir los datos",
              text: "Error de servidor, inténtelo más tarde",
              showConfirmButton: true
            });
            return false
        }
    };

    const phoneChange = async() => {

        let validRegexPhone = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;

        let isPhoneValid = "valid"
        if(NewPhone.trim() === "" || !NewPhone.match(validRegexPhone) || NewPhone.length < 9 || NewPhone.length > 11) {
            isPhoneValid = "invalid"
        } else {
            isPhoneValid = "valid"
        }

        setvalidation2({
            "Phone" : isPhoneValid
        });

        if(isPhoneValid === "invalid") {
            return false
        }

        if(Phone === NewPhone) {
            setEditPhone(false)
            MySwal.close()
        }

        MySwal.fire({
            position: "center",
            html: 
            <div className="FullAlertWidth1">
                <div className="FullAlertUpTitle">Subiendo parámetro...</div>
                <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
            </div>,
            color: "#340066",
            customClass: 'swal-wide',
            showConfirmButton: false,
            width: "100%",
        })

        let parameters = {
            rut: decodedToken.rut,
            phone: NewPhone
        }
    
        let requestOptions = {
            method: 'POST',
            redirect: 'follow',
            headers: {
            "Content-Type": "application/json",
            },
            body: JSON.stringify(parameters)
        };
        
        try{
            
            const resp = await fetch("https://ymc-doc-api.azurewebsites.net/changeprofiledata", requestOptions)
            if (resp.status !== 200){
                MySwal.fire({
                    icon: "error",
                    title: "Ocurrió un error al subir los datos",
                    text: "Por favor inténtelo más tarde",
                    showConfirmButton: true
                });
                return false;
            }

            let resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/changeuserphone", requestOptions)
            if (resp2.status !== 200){
                if(resp2.status !== 500) {
                MySwal.fire({
                    icon: "error",
                    title: "Ocurrió un error confirmando el correo 2",
                    text: "Por favor inténtelo más tarde",
                    showConfirmButton: true
                });
                return false;
                } 
            }

            sessionStorage.setItem('Phone', NewPhone)
    
            setEditPhone(false)
            MySwal.close()
            window.location.reload();
            
            return true
        }
        catch(error){
            MySwal.fire({
            icon: "error",
            title: "Ocurrió un error al subir los datos",
            text: "Error de servidor, inténtelo más tarde",
            showConfirmButton: true
            });
            return false
        }

    }

    const grantAccess = async() => {

        let parameters = {
            rut: decodedToken.rut,
        }
    
        let requestOptions = {
            method: 'POST',
            redirect: 'follow',
            headers: {
            "Content-Type": "application/json",
            },
            body: JSON.stringify(parameters)
        };
        
        try{
            
            const resp = await fetch("https://ymc-doc-api.azurewebsites.net/allowuseraccess", requestOptions)
            if (resp.status !== 200){
            MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al subir los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
            });
            return false;
            }
    
            window.localStorage.setItem("OpenAccess",true)
            setEnoughInfo(true)
            setOpenModal1(false)

            MySwal.fire({
                position: "center",
                html: 
                <div className="FullAlertWidth2">
                    <div className="FullAlertUpTitle">Pasos Siguientes</div>
                    <h3 className="FullAlertTitle">¿Necesitas una orden de exámenes? Te ayudamos</h3>
                    <div className="FullAlertSubtitle" style={{fontWeight:"600"}}>En base a tus antecedentes, diseñamos una orden medica de exámenes preventivos para ti.</div>
                    <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton"  onClick={() => {Navigate("/recomendador-de-examenes"); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                        <div className="GeneralPurpleButtonText">Obtén tu Orden Médica Personalizada</div>
                        <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                    </div>
                    <div className="FullAlertHorizontal"></div>
                    <h3 className="FullAlertTitle">Evalúa tu estado de salud</h3>
                    <div className="FullAlertSubtitle" style={{fontWeight:"600"}}>Toma el control de tu salud y previene a tiempo. Aquí podrás evaluar tus hábitos de vida, de sueño y riesgo cardiometabólico.</div>
                    <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton"  onClick={() => {Navigate("/perfil-de-usuario/calculadora-de-salud"); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                        <div className="GeneralPurpleButtonText">Evalua tu Estado de Salud Aquí</div>
                        <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                    </div>
                    <div className="FullAlertHorizontal"></div>
                    <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton FullAlertButton" onClick={() => {MySwal.close(); setReload(true);}}>
                        <div className="GeneralButtonText">Cerrar</div>
                    </div>
                </div>,
                color: "#340066",
                customClass: 'swal-wide',
                showConfirmButton: false,
                width: "100%",
                allowOutsideClick: false
            })
            return true
        }
        catch(error){
            MySwal.fire({
            icon: "error",
            title: "Ocurrió un error al subir los datos",
            text: "Error de servidor, inténtelo más tarde",
            showConfirmButton: true
            });
            return false
        }
    };

    const uploadMedhis = async(type) => {

        if(type === 1 && TmpFMH.includes("AF025") && !FamCardio) {
            setFamCardioMissing(true)
            return
        } else {
            if(type === 1 && TmpFMH.includes("AF025")) {
                setFamCardio(false)
            }
            setFamCardioMissing(false)
        }

        MySwal.fire({
            position: "center",
            html: 
            <div className="FullAlertWidth1">
                <div className="FullAlertUpTitle">Subiendo parámetro...</div>
                <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
            </div>,
            color: "#340066",
            customClass: 'swal-wide',
            showConfirmButton: false,
            width: "100%",
        })

        let personal = TmpPMH
        let familiar = TmpFMH

        if(cardios.some(r=> personal.includes(r))) {
            personal = personal.filter( ( el ) => !cardios.includes( el ) );
            if(!personal.includes("AP035")) {
                personal.push("AP035")
            }
        } else {
            personal = personal.filter( ( el ) => el !== "AP035" );
            setShowCardios(false)
        }
        let allpersonals = personal.concat(Cardios)

        let parameters = {
            rut: decodedToken.rut,
            pers: type === 0 ? personal : false,
            fam: type === 1 ? familiar : false,
            enf_card: type === 0 && personal.includes("AP035") && Cardios.length !== 0 ? Cardios : false,
            fam_card: type === 1 && FamCardio ? FamCardio : false
        }
    
        let requestOptions = {
            method: 'POST',
            redirect: 'follow',
            headers: {
            "Content-Type": "application/json",
            },
            body: JSON.stringify(parameters)
        };

        let Dated = new Date()
    
        let parameters2 = {
          rut: decodedToken.rut,
          sex: GenderCat,
          pmh: type === 0 ? allpersonals : false,
          fmh: type === 1 ? familiar : false,
          date: Dated
        }
    
        let requestOptions2 = {
            method: 'POST',
            redirect: 'follow',
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(parameters2)
        };

        let containsAll = (arr1, arr2) => arr2.every(arr2Item => arr1.includes(arr2Item))
            
        const sameMembers = (arr1, arr2) => containsAll(arr1, arr2) && containsAll(arr2, arr1);

        if((type === 0 && sameMembers(PMH, personal) && sameMembers(Cardios, CardioUp)) || (type === 1 && sameMembers(FMH, familiar))) {
            MySwal.close()
            setOpenModal2(false)
            setOpenModal3(false)
            return true
        }

        try{
            
            const resp = await fetch("https://ymc-doc-api.azurewebsites.net/updateusermedhis", requestOptions)
            if (resp.status !== 200){
              MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al subir los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
              });
              return false;
            }

            const resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/addnewparamresults", requestOptions2)
            if (resp2.status !== 200){
              MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al subir los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
              });
              return false;
            }
      
            MySwal.close()
            setOpenModal2(false)
            setOpenModal3(false)
            if(type === 0) {
                setPMH([...personal])
            } else {
                setFMH([...TmpFMH])
            }

            return true
        }
        catch(error){
            MySwal.fire({
              icon: "error",
              title: "Ocurrió un error al subir los datos",
              text: "Error de servidor, inténtelo más tarde",
              showConfirmButton: true
            });
            return false
        }
    }

    useEffect(() => {
        if(OneTime) {
            if(!sessionStorage.getItem('token')) {
                Navigate("/")
            }
            requestGetPatient()
            setOneTime(false)
        }

        if(!sessionStorage.getItem('token')) {
            Navigate("/")
        }

        if(LoggedOut) {
            MySwal.close();
        }

        if(Reload) {
            window.location.reload();
        }
    }, [OneTime, LoggedOut, requestGetPatient, Navigate, MySwal, Reload]);

    const handleMedTiles = (ActiveKey,type) => {
        let tmp = document.getElementById(ActiveKey);
        let tmpList = type === 0 ? TmpPMH : TmpFMH
        let code = type === 0 ? PerRecordsCodes[ActiveKey] : FamRecordsCodes[ActiveKey]
        let cards = Cardios
    
        if(tmp.className.includes("GenderTileActive")) {
          tmp.className = tmp.className.replace("GenderTileActive", "GenderTile");
          let index = tmpList.indexOf(code);
          if (index > -1) { 
            tmpList.splice(index, 1); 
          }
          if(cardios.includes(code)) {
            cards = cards.filter( ( el ) => el !== code );
          }
        } else {
          tmp.className = tmp.className.replace("GenderTile", "GenderTileActive");
          tmpList.push(code)
          if(cardios.includes(code)) {
            cards.push(code)
          }
        }
        
        if(type === 0) {
          setTmpPMH([...new Set(tmpList)])
          setCardios([...cards])
        } else {
          setTmpFMH([...new Set(tmpList)])
        }
    }

    function showCancer() {
        let tmp = document.getElementById("CancerButton");
        let tmp2 = document.getElementById("CancerDiv");
        let tmpList = TmpFMH
    
        if(tmp.className.includes("GenderTileActive")) {
          tmp.className = tmp.className.replace("GenderTileActive", "GenderTile");
          tmp2.className += " FamilyFormBlockHidden"
          for(let i=0;i<medhistory.Family_Cancer.length;i++) {
            if(tmpList.includes(medhistory.Family_Cancer[i])) {
              let index = tmpList.indexOf(medhistory.Family_Cancer[i]);
              tmpList.splice(index, 1);
            }
          }
        } else {
          tmp.className = tmp.className.replace("GenderTile", "GenderTileActive");
          tmp2.className = tmp2.className.replace(" FamilyFormBlockHidden", "");
        }
        setTmpFMH([...tmpList])
    }

    function showCardio() {
        let tmp = document.getElementById("CardioButton");
        let tmp2 = document.getElementById("CardioDiv");
        let tmpList = TmpPMH
    
        if(tmp.className.includes("GenderTileActive")) {
          tmp.className = tmp.className.replace("GenderTileActive", "GenderTile");
          tmp2.className += " FamilyFormBlockHidden"
          for(let i=0;i<medhistory.Per_Cardio.length;i++) {
            if(tmpList.includes(medhistory.Per_Cardio[i])) {
              let index = tmpList.indexOf(medhistory.Per_Cardio[i]);
              tmpList.splice(index, 1);
            }
          }
        } else {
          tmp.className = tmp.className.replace("GenderTile", "GenderTileActive");
          tmp2.className = tmp2.className.replace(" FamilyFormBlockHidden", "");
        }
        if(ShowCardios) {
            setCardios([])
            tmpList = tmpList.filter( ( el ) => !cardios.includes( el ) );
        }
        setShowCardios(!ShowCardios)
        setTmpPMH([...tmpList])
    }

    function displayBlock(num) {
        let tmp = document.getElementById("Block"+num)
        let tmp2 = document.getElementById("Arrow"+num)
        if(!tmp.className.includes("UserWelcomeBlockPage1SpecificsHidden")) {
            tmp.className += " UserWelcomeBlockPage1SpecificsHidden"
            tmp2.style.transform = 'rotate(0deg)'
        } else {
            tmp.className = tmp.className.replace(" UserWelcomeBlockPage1SpecificsHidden", "")
            tmp2.style.transform = 'rotate(180deg)'
        }
    }

    function toggleAdditional(id) {
        let tmp = document.getElementById(id)
        if(tmp.className.includes("UserWelcomeBlockPage1SpecificsHidden")) {
          tmp.className = tmp.className.replace(" UserWelcomeBlockPage1SpecificsHidden", "");
        } else {
          tmp.className += " UserWelcomeBlockPage1SpecificsHidden"
        }
    }

    return (
        <div className='UserProfileFull2'>
            {TaskDone ?
            <div className='UserProfileInnerDiv'>
                <div className='UserProfilePageFlex'>
                    <div className='UserProfilePageWhiteBox'>
                        <div className='UserProfilePageUpTitle'>Perfil de Salud</div>
                        <img  alt="" className='UserProfilePageLeftImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage3Vect_NoMargins.svg"/>
                        <h3 className='UserProfilePageTitle'>{Name ? Name : "-"}</h3>
                        <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                            <div className="UserProfilePageBlueText">Correo electronico:</div>
                            <div className="UserProfilePageBlueText">{Email ? Email : "-"}</div>
                        </div>
                        <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>Rut:</div>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>{Rut ? Rut : "-"}</div>
                        </div>
                        <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>Fecha de Nacimiento:</div>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>{DoB ? DoB.toLocaleDateString('fr-ca') : "-"}</div>
                        </div>
                        <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>Sexo de Nacimiento:</div>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>{Gender === 1 ? "Hombre" : "Mujer"}</div>
                        </div>
                        {EditPhone ?
                        <div className='UserProfileHealthReportUpperBlockRightSideDivideEditable'>
                            <input
                                value={NewPhone}
                                className="SignInInnerBoxInputTile"
                                style={{ borderBottom: validation2["Phone"] === "invalid" ? "red solid 1px" : validation2["Phone"] === "valid" ? "#8BC53F solid 1px" : Phone.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation2["Phone"] === "invalid" ? "#FFFAEA" : validation2["Phone"] === "valid" || Phone.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                id="YMCPhone"
                                maxLength={20}
                                type="tel"
                                onChange={(e) => setNewPhone(e.target.value)}
                                placeholder="Tel +56" />
                            {validation["Phone"] === "invalid" ?
                                <div className='SignInAlert' style={{ color: "red", fontWeight: "500" }}> Por favor ingrese teléfono válido</div>
                            : null}
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideButtonFlex'>
                                <div className='GeneralWhiteButtonFlex' onClick={() => setEditPhone(false)}>Cancelar</div>
                                <div className='GeneralPurpleButtonFlex' onClick={() => phoneChange()}>Guardar</div>
                            </div>
                        </div>
                        :
                        <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>
                                <div style={{textAlign:"left"}}>Teléfono:</div>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRightEdit' onClick={() => {setEditPhone(true); setNewPhone(Phone);}}>
                                    <div style={{marginBlock:"auto"}}>Editar</div>
                                    <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                                </div>
                            </div>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>{Phone ? "(+56) "+Phone : "-"}</div>
                        </div>
}
                        <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>Región:</div>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>{Region ? Region : "-"}</div>
                        </div>
                        <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>Comuna:</div>
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideFlexRight'>{Commune ? Commune : "-"}</div>
                        </div>
                    </div>
                    <div className='UserProfilePageWhiteBox'>
                        <h5 className='UserProfilePageTitle2'>Mi Historial Médico</h5>
                        {PMH.length !== 0 ?
                        <div className='UserProfilePageRightInnerBox'>
                            <div className='UserProfilePageRightInnerBoxTitleFlex'>
                                <div className='UserProfilePageRightInnerBoxTitleInnerFlex' onClick={() => displayBlock(2)}>
                                    <img alt="Down Arrow" id="Arrow2" className='UserProfileInnerDivCalculatorWhiteBlockDoneBlockIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleDownArrowIcon.png" />
                                    <div className='UserProfilePageRightInnerBoxTitle'>Antecedentes Personales</div>
                                </div>
                                <img alt="" className='UserProfilePageRightInnerBoxTitlePlusIcon UserProfilePageRightInnerBoxPlusPale' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg"  onClick={() => setOpenModal2(true)}/>
                            </div>
                            <div id="Block2" className='UserProfilePageRightInnerBoxContent UserWelcomeBlockPage1SpecificsHidden'>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLeft'>Estado Nutricional:</div>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLong'>{IMC ? IMC[1] : "-"}</div>
                                </div>
                                {PMH.includes("AP002") ?
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLeft'>Diabetes:</div>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLong'>SÍ</div>
                                </div>
                                : null}
                                {PMH.includes("AP035") ?
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLeft'>Enfermedades Cardiovasculares:</div>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLong'>{Cardios.length !== 0 ? Cardios.map((med) => String(medhisCodes[med])).join(', ') : "-"}</div>
                                </div>
                                : null}
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLeft'>Otros:</div>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLong'>{PMH.filter((med) => med !== "AP002" && med !== "AP035").length === 0 ? "-" : PMH.filter((med) => med !== "AP002" && med !== "AP035").map((med) => String(medhisCodes[med])).join(', ')}</div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className='GeneralWhiteButtonFlex UserProfileInnerDivCalculatorWhiteBlockRightButton' onClick={() => setOpenModal2(true)}>
                            <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonInner'>
                                <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonText'>Antecedentes Personales</div>
                                <img alt="Plus Icon" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurplePlusCircleIcon.svg" />
                            </div>
                        </div>
}
                        {FMH.length !== 0 ?
                        <div className='UserProfilePageRightInnerBox'>
                            <div className='UserProfilePageRightInnerBoxTitleFlex'>
                                <div className='UserProfilePageRightInnerBoxTitleInnerFlex' onClick={() => displayBlock(3)}>
                                    <img alt="Down Arrow" id="Arrow3" className='UserProfileInnerDivCalculatorWhiteBlockDoneBlockIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleDownArrowIcon.png" />
                                    <div className='UserProfilePageRightInnerBoxTitle'>Antecedentes Familiares</div>
                                </div>
                                <img alt="" className='UserProfilePageRightInnerBoxTitlePlusIcon UserProfilePageRightInnerBoxPlusPale' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" onClick={() => setOpenModal3(true)}/>
                            </div>
                            <div id="Block3" className='UserProfilePageRightInnerBoxContent UserWelcomeBlockPage1SpecificsHidden'>
                                {FMH.filter((med) => cancers.includes(med) ? med : null).length !== 0 ? 
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLeft'>Cáncer:</div>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLong'>{FMH.filter((med) => cancers.includes(med) ? med : null).map((med) => String(medhisCodes[med])).join(', ')}</div>
                                </div>
                                : null}
                                {FMH.includes("AF007") ?
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLeft'>Diabetes:</div>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLong'>SÍ</div>
                                </div>
                                : null}
                                {FamCardio ? 
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLeft'>Enfermedad cardiovascular en padres:</div>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLong'>{FamCardio && FamCardio !== "NA" ? FamCardio : "-"}</div>
                                </div>
                                : null}
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLeft'>Otros:</div>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLong'>{FMH.filter((med) => !cancers.includes(med) && med !== "AF007" ? med : null).length === 0 ? "-" : FMH.filter((med) => !cancers.includes(med) && med !== "AF007" ? med : null).map((med) => String(medhisCodes[med])).join(', ')}</div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className='GeneralWhiteButtonFlex UserProfileInnerDivCalculatorWhiteBlockRightButton' onClick={() => setOpenModal3(true)}>
                            <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonInner'>
                                <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonText'>Antecedentes Familiares</div>
                                <img alt="Plus Icon" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurplePlusCircleIcon.svg" />
                            </div>
                        </div>
}
                        {Parameters ?
                        <div className='UserProfilePageRightInnerBox'>
                            <div className='UserProfilePageRightInnerBoxTitleFlex'>
                                <div className='UserProfilePageRightInnerBoxTitleInnerFlex' onClick={() => displayBlock(1)}>
                                    <img alt="Down Arrow" id="Arrow1" className='UserProfileInnerDivCalculatorWhiteBlockDoneBlockIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleDownArrowIcon.png" style={{transform:"rotate(180deg)"}} />
                                    <div className='UserProfilePageRightInnerBoxTitle'>Mediciones Corporales</div>
                                </div>
                                <img alt="" className='UserProfilePageRightInnerBoxTitlePlusIcon UserProfilePageRightInnerBoxPlusPale' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" onClick={() => setOpenModal1(true)}/>
                            </div>
                            <div id="Block1" className='UserProfilePageRightInnerBoxContent'>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLeft'>Peso:</div>
                                    <div className='UserProfilePageRightInnerBoxContentParameter'>{Parameters && Parameters["51"] ? String(Parameters["51"][1])+" Kg" : <span className='UserProfilePageRightInnerBoxContentParameterMissing'>Ingresar</span>}</div>
                                </div>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLeft'>Estatura:</div>
                                    <div className='UserProfilePageRightInnerBoxContentParameter'>{Parameters && Parameters["52"] ? String(Parameters["52"][1])+" cm" : <span className='UserProfilePageRightInnerBoxContentParameterMissing'>Ingresar</span>}</div>
                                </div>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLeft'>Perímetro Abdominal:</div>
                                    <div className='UserProfilePageRightInnerBoxContentParameter'>{Parameters && Parameters["56"] ? String(Parameters["56"][1])+" cm" : <span className='UserProfilePageRightInnerBoxContentParameterMissing'>Ingresar</span>}</div>
                                </div>
                                <div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLeft'>Perímetro de Cuello:</div>
                                    <div className='UserProfilePageRightInnerBoxContentParameter'>{Parameters && Parameters["57"] ? String(Parameters["57"][1])+" cm" : <span className='UserProfilePageRightInnerBoxContentParameterMissing'>Ingresar</span>}</div>
                                </div>
                                {/*<div className='UserProfileHealthReportUpperBlockRightSideDivideFlex'>
                                    <div className='UserProfilePageRightInnerBoxContentParameterLeft'>Presión arterial:</div>
                                    {Parameters && (Parameters["53"] || Parameters["54"]) ? 
                                        <div className='UserProfilePageRightInnerBoxContentParameter'>{Parameters["53"] && Parameters["54"] ? String(Parameters["53"][1])+"/"+String(Parameters["54"][1])+" mmHg" : Parameters["54"] ? "-/"+String(Parameters["54"][1])+" mmHg" : String(Parameters["53"][1])+"/- mmHg"}</div>
                                    :
                                        <div className='UserProfilePageRightInnerBoxContentParameter'><span className='UserProfilePageRightInnerBoxContentParameterMissing'>Ingresar</span></div>
                                    }
                                </div>*/}
                            </div>
                        </div>
                        : 
                        <div className='GeneralWhiteButtonFlex UserProfileInnerDivCalculatorWhiteBlockRightButton'  onClick={() => setOpenModal1(true)}>
                            <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonInner'>
                                <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonText'>Mediciones Corporales</div>
                                <img alt="Plus Icon" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurplePlusCircleIcon.svg" />
                            </div>
                        </div>
}
                    {EnoughInfo ?
                    <>
                        <div className='UserProfileBigButton UserProfileBigButtonExtra' onClick={() => {Navigate("/recomendador-de-examenes"); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                            <div className='UserProfileBigButtonBackTexts'>
                                <h4 className='UserProfileBigButtonBackUpText'>Obtén una Orden Médica Personalizada</h4>
                                <div className='UserProfileBigButtonBackUnderText'>En base a tus antecedentes te sugerimos realizar estos exámenes</div>
                            </div>
                            <div className='UserProfileBigButtonBackImageDiv'>
                                <img alt="" className='UserProfileBigButtonBackImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage8Vect.svg" />
                            </div>
                        </div>
                        <div className='UserProfileBigButton' style={{backgroundColor:"#CFF9FF"}} onClick={() => {Navigate("/perfil-de-usuario/calculadora-de-salud"); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                            <div className='UserProfileBigButtonBackTexts'>
                                <h4 className='UserProfileBigButtonBackUpText'>Evalúa tu Estado de Salud</h4>
                                <div className='UserProfileBigButtonBackUnderText'>Toma el control de tu salud y previene a tiempo</div>
                            </div>
                            <div className='UserProfileBigButtonBackImageDiv'>
                                <img alt="" className='UserProfileBigButtonBackImage' src="https://static.yomecontrolo.cl/public/B2B/ProfileWelcomeImage3Vect.svg" />
                            </div>
                        </div>
                    </>
                    : null}
                    </div>
                    <Modal dismissible show={OpenModal1} position="center" className='UserWelcomeBlockModal'>
                        <Modal.Body className='UserWelcomeBlockwModalBody'>
                            <div className='UserWelcomeBlockPage1TitleFlex'>
                                <div className='UserWelcomeBlockPage1Title'>Registra nuevos datos&ensp;</div>
                                <div className="UserWelcomeBlockModalXSymbol" onClick={() => setOpenModal1(false)}></div>
                            </div>
                            <h2 className='UserWelcomeBlockModalBodyTitle'>Mediciones Corporales</h2>
                            <div className='UserProfilePageModalEntry'>
                                <div className='UserProfilePageModalEntryFlex'>
                                    <div className='UserProfilePageModalEntryText' style={{color: validation["Weight"] === "invalid" ? "red" : validation["Weight"] === "valid" ? "#8BC53F" : null}}>Peso*</div>
                                    <div className='UserProfilePageModalEntryInputFlex'>
                                        <input
                                            value={Weight}
                                            className="SignInInnerBoxInputTile UserProfilePageModalEntryInput"
                                            style={{ borderBottom: validation["Weight"] === "invalid" ? "red solid 1px" : validation["Weight"] === "valid" ? "#8BC53F solid 1px" : Weight.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Weight"] === "invalid" ? "#FFFAEA" : validation["Weight"] === "valid" || Weight.length === 0 ?"#FBFFFF" : "#F2F2FF" }}
                                            id="YMCWeight"
                                            onChange={(e) => handleChange(e.target.value,setWeight)}
                                            placeholder="Obligatorio" />
                                        <div className="HeartAgeCalculatorRightSideSurveyQ4InputMeasure">Kg</div>
                                    </div>
                                </div>
                                {validation["Weight"] === "invalid" ?
                                    <div className='BloodAlert' style={{ color: "red", fontWeight: "500", textAlign:"right" }}> Input inválido o fuera de rango </div>
                                : null }
                                <div className='UserProfilePageModalEntryFlex'>
                                    <div className='UserProfilePageModalEntryText' style={{color: validation["Height"] === "invalid" ? "red" : validation["Height"] === "valid" ? "#8BC53F" : null}}>Estatura*</div>
                                    <div className='UserProfilePageModalEntryInputFlex'>
                                        <input
                                            value={Height}
                                            className="SignInInnerBoxInputTile UserProfilePageModalEntryInput"
                                            style={{ borderBottom: validation["Height"] === "invalid" ? "red solid 1px" : validation["Height"] === "valid" ? "#8BC53F solid 1px" : Height.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Height"] === "invalid" ? "#FFFAEA" : validation["Height"] === "valid" || Height.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                            id="YMCHeight"
                                            onChange={(e) => handleChange(e.target.value,setHeight)}
                                            placeholder="Obligatorio" />
                                        <div className="HeartAgeCalculatorRightSideSurveyQ4InputMeasure">cm</div>
                                    </div>
                                </div>
                                {validation["Height"] === "invalid" ?
                                    <div className='BloodAlert' style={{ color: "red", fontWeight: "500", textAlign:"right" }}> Input inválido o fuera de rango </div>
                                : null }
                                <div className='UserProfilePageModalEntryFlex'>
                                    <div className='UserProfilePageModalEntryLeft' style={{width:"100%"}}>
                                        <div className='UserProfilePageModalEntryTextFlex'>
                                            <div className='UserProfilePageModalEntryText' style={{color: validation["Abs"] === "invalid" ? "red" : validation["Abs"] === "valid" ? "#8BC53F" : null}}>Perímetro abdominal</div>
                                            <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional("Added1")}>?</div>
                                        </div>
                                        <div className="UserWelcomeBlockPage1Specifics UserProfilePageModalEntryLeftAdditionalFlex UserWelcomeBlockPage1SpecificsHidden" id="Added1">
                                            <div>Para medir el perímetro abdominal, se debe utilizar una cinta métrica y seguir los siguientes pasos:
                                                <br/>&nbsp;1. Pararse de pie con los pies juntos y los brazos a los lados
                                                <br/>&nbsp;2. Descansar el abdomen
                                                <br/>&nbsp;3. Colocar la cinta métrica alrededor del abdomen, a la altura del ombligo
                                                <br/>&nbsp;4. Inspirar profundamente y al momento de exhalar, tomar la medida
                                            </div>
                                            <img alt="" className="UserProfilePageModalEntryLeftAdditionalImage1" src="https://static.yomecontrolo.cl/public/img/calculator/InstructionsAbdominalPerimeter.png" />
                                        </div>
                                    </div>
                                    <div className='UserProfilePageModalEntryInputFlex' style={{marginBlockEnd:"auto"}}>
                                        <input
                                            value={Abs}
                                            className="SignInInnerBoxInputTile UserProfilePageModalEntryInput"
                                            style={{ borderBottom: validation["Abs"] === "invalid" ? "red solid 1px" : validation["Abs"] === "valid" ? "#8BC53F solid 1px" : Abs.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Abs"] === "invalid" ? "#FFFAEA" : validation["Abs"] === "valid" || Abs.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                            id="YMCAbs"
                                            onChange={(e) => handleChange(e.target.value,setAbs)}
                                            placeholder="Opcional" />
                                        <div className="HeartAgeCalculatorRightSideSurveyQ4InputMeasure">cm</div>
                                    </div>
                                </div>
                                {validation["Abs"] === "invalid" ?
                                    <div className='BloodAlert' style={{ color: "red", fontWeight: "500", textAlign:"right" }}> Input inválido o fuera de rango </div>
                                : null }
                                <div className='UserProfilePageModalEntryFlex'>
                                    <div className='UserProfilePageModalEntryLeft' style={{width:"100%"}}>
                                        <div className='UserProfilePageModalEntryTextFlex'>
                                            <div className='UserProfilePageModalEntryText' style={{color: validation["Neck"] === "invalid" ? "red" : validation["Neck"] === "valid" ? "#8BC53F" : null}}>Perímetro de cuello</div>
                                            <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional("Added2")}>?</div>
                                        </div>
                                        <div className="UserWelcomeBlockPage1Specifics UserProfilePageModalEntryLeftAdditionalFlex UserWelcomeBlockPage1SpecificsHidden" id="Added2">
                                            <div>Para medir la circunferencia del cuello, se debe:
                                                <br/>&nbsp;1. Colocar la cinta métrica justo debajo de la nuez de Adán
                                                <br/>&nbsp;2. Asegurarse de que la cinta métrica sea perpendicular al eje largo del cuello
                                                <br/>&nbsp;3. Pedir a la persona que mire hacia adelante y tenga los hombros hacia abajo
                                            </div>
                                            <img alt="" className="UserProfilePageModalEntryLeftAdditionalImage1" src="https://static.yomecontrolo.cl/public/img/calculator/InstructionsNeckCircumference.png" />
                                        </div>
                                    </div>
                                    <div className='UserProfilePageModalEntryInputFlex' style={{marginBlockEnd:"auto"}}>
                                        <input
                                            value={Neck}
                                            className="SignInInnerBoxInputTile UserProfilePageModalEntryInput"
                                            style={{ borderBottom: validation["Neck"] === "invalid" ? "red solid 1px" : validation["Neck"] === "valid" ? "#8BC53F solid 1px" : Neck.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Neck"] === "invalid" ? "#FFFAEA" : validation["Neck"] === "valid" || Neck.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                            id="YMCNeck"
                                            onChange={(e) => handleChange(e.target.value,setNeck)}
                                            placeholder="Opcional" />
                                        <div className="HeartAgeCalculatorRightSideSurveyQ4InputMeasure">cm</div>
                                    </div>
                                </div>
                                {validation["Neck"] === "invalid" ?
                                    <div className='BloodAlert' style={{ color: "red", fontWeight: "500", textAlign:"right" }}> Input inválido o fuera de rango </div>
                                : null }
                                {/*<div className='UserProfilePageModalEntryFlex'>
                                    <div className='UserProfilePageModalEntryText' style={{color: validation["Systolic"] === "invalid" ? "red" : validation["Systolic"] === "valid" ? "#8BC53F" : null}}>Presión arterial</div>
                                    <div className='UserProfilePageModalEntryInputFlex'>
                                        <div className='UserProfilePageModalEntryInputDoubleFlex'>
                                            <input
                                                value={Systolic}
                                                className="SignInInnerBoxInputTile UserProfilePageModalEntryInput"
                                                style={{ borderBottom: validation["Systolic"] === "invalid" ? "red solid 1px" : validation["Systolic"] === "valid" ? "#8BC53F solid 1px" : Systolic.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Systolic"] === "invalid" ? "#FFFAEA" : validation["Systolic"] === "valid" || Systolic.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                                id="YMCSystolic"
                                                onChange={(e) => handleChange(e.target.value,setSystolic)}
                                                placeholder="Ingresa" />
                                            <div className='UserProfilePageModalEntryMiddleSlash'>/<br className='UserProfilePageModalEntryMiddleSlashJump'/></div>
                                            <input
                                                value={Diastolic}
                                                className="SignInInnerBoxInputTile UserProfilePageModalEntryInput"
                                                style={{ borderBottom: validation["Diastolic"] === "invalid" ? "red solid 1px" : validation["Diastolic"] === "valid" ? "#8BC53F solid 1px" : Diastolic.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Diastolic"] === "invalid" ? "#FFFAEA" : validation["Diastolic"] === "valid" || Diastolic.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                                id="YMCDiastolic"
                                                onChange={(e) => handleChange(e.target.value,setDiastolic)}
                                                placeholder="Ingresa" />
                                        </div>
                                        <div className="HeartAgeCalculatorRightSideSurveyQ4InputMeasure">mmHg</div>
                                    </div>
                                </div>
                                {validation["Systolic"] === "invalid" || validation["Diastolic"] === "invalid" ?
                                    <div className='BloodAlert' style={{ color: "red", fontWeight: "500", textAlign:"right" }}> Input inválido o fuera de rango </div>
                                : null */}
                            </div>
                            <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton UserWelcomeBlockModalSaveButton" onClick={() => verifyData()}>
                                <div className="GeneralPurpleButtonText">Guardar</div>
                                <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                            </div>
                        </Modal.Body>
                    </Modal>
                    <Modal dismissible show={OpenModal2} position="center" className='UserWelcomeBlockModal'>
                        <Modal.Body className='UserWelcomeBlockwModalBody'>
                            <div className='UserWelcomeBlockPage1TitleFlex'>
                            <div className='UserWelcomeBlockPage1Title'>Registra nuevos datos&ensp;</div>
                            <div className="UserWelcomeBlockModalXSymbol" onClick={() => setOpenModal2(false)}></div>
                            </div>
                            <h2 className='UserWelcomeBlockModalBodyTitle'>Antecedentes Personales</h2>
                            <div className='UserProfileHeartAgeCalculatorWhiteBlockTitle' style={{marginInline:"0px"}}>¿Te han diagnosticado o presentas algunas de estas condiciones de salud?</div>
                            <div className='MedicalHistoryFormButtons UserWelcomeBlockModalMedhisGrid'>
                            {Object.keys(medhistory.Personal).filter(a => medhistory.Personal[a].age_cat.includes(ageCat)).filter(a => medhistory.Personal[a].gender.includes(GenderCat)).filter((item) => item !== "Sobrepeso" && item !== "Obesidad").map((history) => (
                                <div className={TmpPMH.includes(PerRecordsCodes[history]) ? "MedicalFormIndividualButton GenderTile rounded-2 GenderTileActive" : "MedicalFormIndividualButton GenderTile rounded-2 "} id={history} key={history+'P'} onClick={() => handleMedTiles(history,0)}>
                                {history} </div>
                            ))}
                            <div className={ShowCardios ? "MedicalFormIndividualButton GenderTile rounded-2 GenderTileActive" : "MedicalFormIndividualButton GenderTile rounded-2 "} id="CardioButton" onClick={() => showCardio()}>
                            Enfermedad Cardiovascular</div>
                            </div>
                            <div className={ShowCardios ? "FamilyFormBlock" : "FamilyFormBlock FamilyFormBlockHidden"} id="CardioDiv">
                                <div className='UserProfileHeartAgeCalculatorWhiteBlockTitle' style={{marginInline:"0px"}}>Seleccione el(los) tipo(s) de enfermedades cardiovasculares.</div>
                                <div className='MedicalHistoryFormButtons'>
                                    {medhistory.Per_Cardio.map((history) => (
                                    <div className={Cardios.includes(PerRecordsCodes[history]) ? "MedicalFormIndividualButton GenderTile rounded-2 GenderTileActive" : "MedicalFormIndividualButton GenderTile rounded-2 "} key={history+'P'} id={history} onClick={() => handleMedTiles(history,0)}>
                                        {history} </div>
                                    ))}
                                </div>
                            </div>
                            <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton UserWelcomeBlockModalSaveButton" onClick={() => uploadMedhis(0)}>
                                <div className="GeneralPurpleButtonText">Guardar</div>
                                <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                            </div>
                        </Modal.Body>
                    </Modal>
                    <Modal dismissible show={OpenModal3} position="center" className='UserWelcomeBlockModal'>
                        <Modal.Body className='UserWelcomeBlockwModalBody'>
                            <div className='UserWelcomeBlockPage1TitleFlex'>
                            <div className='UserWelcomeBlockPage1Title'>Registra nuevos datos&ensp;</div>
                            <div className="UserWelcomeBlockModalXSymbol" onClick={() => setOpenModal3(false)}></div>
                            </div>
                            <h2 className='UserWelcomeBlockModalBodyTitle'>Antecedentes Familiares</h2>
                            <div className='UserProfileHeartAgeCalculatorWhiteBlockTitle' style={{marginInline:"0px"}}>¿Sabes si alguno de tus familiares directos (como padres, hermanos, tíos y abuelos) ha sido diagnosticado o está en tratamiento por alguna de estas patologias?</div>
                            <div className="FamilyFormBlock">
                            <div className='MedicalHistoryFormButtons'>
                            {medhistory.Family_Patho.map((history) => (
                                <div className={TmpFMH.includes(FamRecordsCodes[history]) ? "FamilyFormIndividualButton GenderTile rounded-2 GenderTileActive" : "FamilyFormIndividualButton GenderTile rounded-2 "} key={history+'F'} id={history} onClick={() => handleMedTiles(history,1)}>
                                {history} </div>
                            ))}
                            <div className={TmpFMH.filter(s => s.includes("Cáncer")).length !== 0 ? "FamilyFormIndividualButton GenderTile rounded-2 GenderTileActive" : "FamilyFormIndividualButton GenderTile rounded-2 "} id="CancerButton" onClick={() => showCancer()}>
                                Cáncer </div>
                            </div>
                            </div>

                            <div className={TmpFMH.filter(s => s.includes("Cáncer")).length !== 0  ? "FamilyFormBlock" : "FamilyFormBlock FamilyFormBlockHidden"} id="CancerDiv">
                                <div className='UserProfileHeartAgeCalculatorWhiteBlockTitle' style={{marginInline:"0px"}}>Seleccione el(los) tipo(s) de cáncer</div>
                                <div className='MedicalHistoryFormButtons'>
                                    {medhistory.Family_Cancer.map((history) => (
                                    <div className={TmpFMH.includes(FamRecordsCodes[history]) ? "FamilyFormIndividualButton GenderTile rounded-2 GenderTileActive" : "FamilyFormIndividualButton GenderTile rounded-2 "} key={history+'F'} id={history} onClick={() => handleMedTiles(history,1)}>
                                        {history} </div>
                                    ))}
                                </div>
                            </div>

                            {TmpFMH.includes('AF025') ?
                            <div className="FamilyFormBlock">
                                <div className='UserProfileHeartAgeCalculatorWhiteBlockTitle' style={{marginInline:"0px"}}>¿Algún familiar de primer grado (padre o madre) tuvo una enfermedad cardiovascular antes de los 55 años en hombres o antes de los 65 años en mujeres?</div>
                                <div className='MedicalHistoryFormButtons'>
                                    <div className={FamCardio === "NO" ? "FamilyFormIndividualButton GenderTile rounded-2 GenderTileActive" : "FamilyFormIndividualButton GenderTile rounded-2 "} style={{border: FamCardioMissing && !FamCardio ? "1px solid red" : null}} onClick={() => FamCardio === "NO" ? setFamCardio(false) : setFamCardio("NO")}>
                                        NO </div>
                                    <div className={FamCardio === "SÍ" ? "FamilyFormIndividualButton GenderTile rounded-2 GenderTileActive" : "FamilyFormIndividualButton GenderTile rounded-2 "} style={{border: FamCardioMissing && !FamCardio ? "1px solid red" : null}} onClick={() => FamCardio === "SÍ" ? setFamCardio(false) : setFamCardio("SÍ")}>
                                        SÍ </div>
                                    <div className={FamCardio === "NA" ? "FamilyFormIndividualButton GenderTile rounded-2 GenderTileActive" : "FamilyFormIndividualButton GenderTile rounded-2 "} style={{border: FamCardioMissing && !FamCardio ? "1px solid red" : null}} onClick={() => FamCardio === "NA" ? setFamCardio(false) : setFamCardio("NA")}>
                                        No sé / No recuerdo</div>
                                </div>
                                {FamCardioMissing && !FamCardio ?
                                    <div className='BloodAlert' style={{ color: "red", fontWeight: "500" }}> Elija una opción en la pregunta anterior</div>
                                : null }
                            </div>
                            : null}
                            <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton UserWelcomeBlockModalSaveButton" onClick={() => uploadMedhis(1)}>
                            <div className="GeneralPurpleButtonText">Guardar</div>
                            <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
            : null}
        </div>
    );
};

export default UserProfileMedicalData;